<template>
  <div
    class="sign-up-error"
    data-testid="sign-up-error"
    role="alert"
  >
    <AkParagraph class="sign-up-error__message">
      {{ t('Something went wrong. Please reload the page and retry') }}
    </AkParagraph>
    <AkButton
      size="lg"
      data-testid="sign-up-error-reload"
      @click="reloadPage"
    >
      {{ t('global.reloadPage') }}
    </AkButton>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import { AkButton, AkParagraph } from '@ankorstore/design-system';

defineOptions({
  name: 'SignUpError',
  // Vue renders this with `{ error: error.value }`; the loader error is already reported
  // from the shared loader's onError (sign-up/async-sign-up.ts) and is not something to spell
  // out to a shopper, so it must not fall through onto the root as an `error="Error: ..."`.
  inheritAttrs: false,
});

const { t } = useI18n();

// A reload is the actual recovery for the case this covers -- a stale document asking for
// a chunk hash that no longer exists -- but it stays a deliberate click. Reloading on our own
// would drop whatever the shopper had behind the modal or already filled in on the page, and
// would repeat on every render for as long as the chunk stays broken.
const reloadPage = () => window.location.reload();
</script>

<style lang="scss" scoped>
.sign-up-error {
  @apply ds-flex ds-flex-col ds-items-center ds-justify-center ds-gap-4 ds-min-h-[320px] ds-text-center;

  &__message {
    @apply ds-text-neutral-700;
  }
}
</style>
